import { BaseProyectaService } from "./base-proyecta.service";
import {
  ICmdSpfrStep1,
  ICmdSpfrStep1Update,
  ICmdSpfrStep2Update,
  ICmdSpfrStep3Update,
  ICmdSpfrStep4,
  ICmdSpfrStep4Update,
  ICmdSpfrStepSDCUpdate,
  IDtoAdtZonaSave,
  IDtoGetStep1,
  IDtoGetStep2,
  IDtoGetStep3,
  IDtoGetStep4,
  IDtoSpfrStep4BaseLine,
  IDtoSpfrStep4Products,
  IDtoGetStepSDC,
  IDtoStep2,
  IDtoStepSDC,
  IFEStep1,
  IFEStep1Anio,
  IFEStep1Beneficiario,
  IFEStep1Dto,
  IFEStep2,
  IFEStep2Dto,
  IFEStep2DtoModel,
  IFEStep3,
  IFEStep3Dto,
  IFEStep4,
  IFEStep4Actividad,
  IFEStep4ActivitiesDtoModel,
  IFEStep4Dto,
  IFEStep4IndicadoresDtoModel,
  IFEStep4IndicadorMri,
  IFEStep4IndicadorObjetivo,
  IFEStep4MriIndicadorDtoModel,
  IFEStep4ResultadoEsperado,
  IFEStep4ResultadoEsperadoDetalle,
  IFEStep4ResultsDetailsDtoModel,
  IFEStep4ResultsDtoModel,
  IFileDto,
  IFileResponse,
  IGetFEQuery,
  ISpfrStep1,
  ISpfrStep1Anio,
  ISpfrStep1Beneficiary,
  ISpfrStep2,
  ISpfrStep2Anio,
  ISpfrStep3,
  ISpfrStep3Anios,
  ISpfrStep4,
  ISpfrStep4LineaBase,
  ISpfrStep4LineaBaseAnios,
  ISpfrStep4Productos,
  ISpfrStep4ProductosAnios,
  ISpfrStepSDC,
  ISpfrStepSDCAnio,
} from "@models/*";
import { Enums, Constants, String, Utilities, moment } from "@utils";
import { promises } from "dns";

export class SPSubProjectExtentionService extends BaseProyectaService {
  //#region Create
  protected async saveStep1(stepData: ICmdSpfrStep1, userId: number): Promise<any> {
    stepData.genericInfo.PProaAnioLineaBase = stepData.genericInfo.PProaAnioLineaBase ? `${(Number(stepData.genericInfo.PProaAnioLineaBase.getMonth())+1)}/${stepData.genericInfo.PProaAnioLineaBase.getFullYear()}` : null;
    (stepData.genericInfo as any).PProaModifiedById = userId;
    stepData.genericInfo.PPresIndicadorLineaEstrategica1Id = Array.isArray(stepData.genericInfo.PPresIndicadorLineaEstrategica1Id) ? stepData.genericInfo.PPresIndicadorLineaEstrategica1Id.length > 0 ? stepData.genericInfo.PPresIndicadorLineaEstrategica1Id[0] : null : stepData.genericInfo.PPresIndicadorLineaEstrategica1Id; 

    let step1ApiResponse = await this.spListService.addItem({
      listName: Enums.ListTypes.ProaSubproyectoFRStep1,
      item: stepData.genericInfo,
    });

    await Promise.all([this.saveStep1BaseLine(stepData.baseLineYears, step1ApiResponse.Id), 
      this.saveStep1Beneficiaries(
        stepData.beneficiaries,
        step1ApiResponse.Id
      )
    ]);

    if (stepData.files && stepData.files.length > 0) {
      let promises = stepData.files.map(async (file: IFileDto) => {
        return await this.spFileService.uploadFile(file.file, {
          PProaFRStep1Id: step1ApiResponse.Id,
          Title: file.fileName,
          OCTAVIADatosGeneralesCodigoProyecto: file.OCTAVIADatosGeneralesCodigoProyecto,
          PPresLineaInter: file.PPresLineaInter,
          PProaFinanciador: file.PProaFinanciador,
          PProaPaisRegion: file.PProaPaisRegion
        });
      });

      await Promise.all(promises);
    }

    return step1ApiResponse;
  }

  protected async saveStep1BaseLine(
    baseLines: Array<ISpfrStep1Anio>,
    step1Id: number
  ): Promise<any> {
    return await Promise.all(
      baseLines.map(async (data: ISpfrStep1Anio) => {
        data.PProaFRStep1Id = step1Id;
        return await this.spListService.addItem({
          listName: Enums.ListTypes.ProaSubproyectoFRStep1Anios,
          item: data,
        });
      })
    );
  }

  protected async saveStep1Beneficiaries(
    beneficiaries: Array<ISpfrStep1Beneficiary>,
    step1Id: number
  ): Promise<any> {
    return await Promise.all(
      beneficiaries.map(async (data: ISpfrStep1Beneficiary) => {
        data.PProaFRStep1Id = step1Id;
        return await this.spListService.addItem({
          listName: Enums.ListTypes.BaseFFRRBeneficiarios,
          item: data,
        });
      })
    );
  }

  protected async saveFEStep1Beneficiaries(
    beneficiaries: Array<IFEStep1Beneficiario>,
    step1Id: number
  ): Promise<any> {
    return await Promise.all(
      beneficiaries.map(async (data: IFEStep1Beneficiario) => {
        data.PProaFRStep1Id = step1Id;
        return await this.spListService.addItem({
          listName: Enums.ListTypes.BaseFFRRBeneficiarios,
          item: data,
        });
      })
    );
  }

  protected async saveStep2(
    stepData: Array<IDtoStep2>,
    budgetId: number
  ): Promise<any> {
    return await Promise.all(
      stepData.map(async (data: IDtoStep2) => {
        data.basicInfo.PPresPresupuestoId = budgetId;
        let apiResponse = await this.spListService.addItem({
          listName: Enums.ListTypes.ProaSubproyectoFRStep2,
          item: data.basicInfo,
        });

        return await Promise.all(
          data.implementerYears.map(async (data: ISpfrStep2Anio) => {
            data.PProaFRStep2Id = apiResponse.Id;
            return await this.spListService.addItem({
              listName: Enums.ListTypes.ProaSubproyectoFRStep2Anios,
              item: data,
            });
          })
        );
      })
    );
  }

  protected async saveFEStep2Back(
    stepData: Array<IFEStep2DtoModel>
  ): Promise<any> {
    if (Utilities.isNullObject(stepData)) {
      return null;
    }
    return await Promise.all(
      stepData.map(async (step: IDtoStep2) => {
        let apiResponse = await this.spListService.addItem({
          listName: Enums.ListTypes.ProaSubproyectoFRStep2,
          item: step.basicInfo,
        });
  
        return await Promise.all(
          step.implementerYears.map(async (data: ISpfrStep2Anio) => {
            data.PProaFRStep2Id = apiResponse.Id;
            return await this.spListService.addItem({
              listName: Enums.ListTypes.ProaSubproyectoFRStep2Anios,
              item: data,
            });
          })
        )
      })
    );
  }

  protected async saveStep3(
    stepData: Array<IDtoAdtZonaSave>,
    budgetId: number
  ): Promise<any> {
    return await Promise.all(
      stepData.map(async (adtZona: IDtoAdtZonaSave) => {
        if (!Utilities.isNullObject(adtZona) && !Utilities.isNullObject(adtZona.genericInfo)) {
          adtZona.genericInfo.PPresPresupuestoId = budgetId;
          let adtSaved = await this.spListService.addItem({
            listName: Enums.ListTypes.ProaSubproyectoFRStep3,
            item: adtZona.genericInfo,
          });

          return await Promise.all(
            adtZona.details.map(async (adtDetail: ISpfrStep3Anios) => {
              adtDetail.PProaFRStep3Id = adtSaved.Id;
              return await this.spListService.addItem({
                listName: Enums.ListTypes.ProaSubproyectoFRStep3Anios,
                item: adtDetail,
              });
            })
          );
        }
      })
    );
  }

  protected async saveFEStep3Back(
    stepData: Array<IDtoAdtZonaSave>
  ): Promise<any> {
    
    return await Promise.all(
      stepData.map(async (adtZona: IDtoAdtZonaSave) => {
        if (!Utilities.isNullObject(adtZona) && !Utilities.isNullObject(adtZona.genericInfo)) {
          let adtSaved = await this.spListService.addItem({
            listName: Enums.ListTypes.ProaSubproyectoFRStep3,
            item: adtZona.genericInfo,
          });

          for (const adtDetail of adtZona.details) {
            adtDetail.PProaFRStep3Id = adtSaved.Id;
            await this.spListService.addItem({
              listName: Enums.ListTypes.ProaSubproyectoFRStep3Anios,
              item: adtDetail,
            });
          }

          return adtSaved;
        }
      })
    )
  }  

  protected async saveStepSDC(
    stepData: Array<IDtoStepSDC>,
    budgetId: number,
    currentUserId: number
  ): Promise<any> {
    for (let i = 0; i < stepData.length; i++) {
      stepData[i].basicInfo.PPresPresupuestoId = budgetId;
      stepData[i].basicInfo.PProaModifiedById = currentUserId;

      let apiResponse = await this.spListService.addItem({
        listName: Enums.ListTypes.ProaSubproyectoFRStepSDC,
        item: stepData[i].basicInfo,
      });

      stepData[i].counterpartYears.map(async (data: ISpfrStepSDCAnio) => {
        data.PProaContrapartidaId = apiResponse.Id;
        data.PProaModifiedById = currentUserId;
        return await this.spListService.addItem({
          listName: Enums.ListTypes.ProaSubproyectoFRStepSDCAnios,
          item: data,
        });
      })
    }

    return true;
  }

  protected async saveFEStep1Back(stepData: IFEStep1Dto, userId: number) {
    (stepData.genericInfo as any).PProaAnioLineaBase = stepData.genericInfo.PProaAnioLineaBase ? `${(Number((stepData.genericInfo as any).PProaAnioLineaBase.getMonth())+1)}/${(stepData.genericInfo as any).PProaAnioLineaBase.getFullYear()}` : null;
    (stepData.genericInfo as any).PProaModifiedById = userId;
    stepData.genericInfo.PPresIndicadorLineaEstrategica1Id = Array.isArray(stepData.genericInfo.PPresIndicadorLineaEstrategica1Id) ? stepData.genericInfo.PPresIndicadorLineaEstrategica1Id.length > 0 ? stepData.genericInfo.PPresIndicadorLineaEstrategica1Id[0] : null : stepData.genericInfo.PPresIndicadorLineaEstrategica1Id; 

    let step1ApiResponse = await this.spListService.addItem({
      listName: Enums.ListTypes.ProaSubproyectoFRStep1,
      item: stepData.genericInfo,
    });

    await Promise.all([this.saveStep1BaseLine(stepData.baseLineYears, step1ApiResponse.Id), 
      this.saveFEStep1Beneficiaries(
        stepData.beneficiaries,
        step1ApiResponse.Id
      )
    ]);

    if (stepData.files && stepData.files.length > 0) {
      let promises = stepData.files.map(async (file: IFileDto) => {
        return await this.spFileService.uploadFile(file.file, {
          PProaFRStep1Id: step1ApiResponse.Id,
          Title: file.fileName,
          OCTAVIADatosGeneralesCodigoProyecto: file.OCTAVIADatosGeneralesCodigoProyecto,
          PPresLineaInter: file.PPresLineaInter,
          PProaFinanciador: file.PProaFinanciador,
          PProaPaisRegion: file.PProaPaisRegion
        });
      });

      await Promise.all(promises);
    }

    return step1ApiResponse;
  }

  //#endregion

  //#region Get
  protected async getBudgetHeader(budgetId: number) {
    const CurrentBudget = await this.spListService.getItem({
      listName: Enums.ListTypes.BaseBudget,
      itemId: budgetId,
      columnsToSelect: Constants.Selects.BUDGET_BASIC,
      expands: Constants.Expands.BUDGET_BASIC,
    });
    return CurrentBudget;
  }

  protected async getInterventionLineObjetive(interventionLineId: number) {
    return await this.spListService.getItems({
      listName: Enums.ListTypes.InterventionLine,
      filter: String.Format(
        Constants.FiltersFormats.FILTER_BY_ID,
        interventionLineId
      ),
    });
  }

  protected getTitleTranslate(langLabel: string, object: any): string {
    let response: string = String.Empty;
    if (!Utilities.isNullObject(object)) {
      response = object.Title;
      switch (langLabel.toLocaleUpperCase()) {
        case Enums.LangLabels.PT:
          response = object.OCTAVIANombrePT;
          break;
        case Enums.LangLabels.EN:
          response = object.OCTAVIANombreEn;
          break;
        case Enums.LangLabels.FR:
          response = object.OCTAVIANombreFR;
          break;
      }
    }
    return response;
  }

  protected getTraductionInterventionLine(
    langLabel: string,
    interventionLine: any,
    budgetId: number
  ): any {
    if (!Utilities.isNullEmptyObject(interventionLine)) {
      switch (langLabel.toLocaleUpperCase()) {
        case Enums.LangLabels.PT:
          interventionLine.Title = interventionLine.OCTAVIANombrePT;
          break;
        case Enums.LangLabels.EN:
          interventionLine.Title = interventionLine.OCTAVIANombreEn;
          break;
        case Enums.LangLabels.FR:
          interventionLine.Title = interventionLine.OCTAVIANombreFR;
          break;
      }
    }
    return interventionLine;
  }

  protected async getStep1(budgetId: number): Promise<IDtoGetStep1 | null> {
    let step1Response = await this.spListService.getItems<ISpfrStep1>({
      listName: Enums.ListTypes.ProaSubproyectoFRStep1,
      filter: String.Format(
        Constants.FiltersFormats.FILTER_BY_BUDGET_GRANT_CODE_NULL,
        budgetId
      ),
    });

    if (Utilities.isNullObject(step1Response) || step1Response.length === 0) {
      return null;
    }

    let genericInfo = {
      ...step1Response[0], 
      OCTAVIAFechaInicio: moment.utc(step1Response[0].OCTAVIAFechaInicio).tz(Constants.GeneralFormats.TIME_ZONE).format(Constants.GeneralFormats.DATE_FORMAT),
      OCTAVIAFechaFinalizacion: moment.utc(step1Response[0].OCTAVIAFechaFinalizacion).tz(Constants.GeneralFormats.TIME_ZONE).format(Constants.GeneralFormats.DATE_FORMAT)
    }    

    let [baseLineYears, beneficiaries, filesSP] = await Promise.all([this.spListService.getItems<ISpfrStep1Anio>({
      listName: Enums.ListTypes.ProaSubproyectoFRStep1Anios,
      filter: String.Format(
        Constants.FiltersFormats.FILTER_PROA_SUBPROJECT_STEP1,
        genericInfo.Id
      ),
      order: "PPresAnioMeta",
    }), this.spListService.getItems<ISpfrStep1Beneficiary>({
      listName: Enums.ListTypes.BaseFFRRBeneficiarios,
      filter: String.Format(
        Constants.FiltersFormats.FILTER_PROA_SUBPROJECT_STEP1,
        genericInfo.Id
      ),
      order: "PPresuAnio",
    }), this.spFileService.getFiles(genericInfo.Id)]) as any;

    let files: Array<IFileDto> = filesSP.map((file: IFileResponse) => {
      return {
        fileName: file.File.Name,
        filePreviewUrl: file.ServerRedirectedEmbedUri,
        fileRelativeUrl: file.File.ServerRelativeUrl,
        OCTAVIADatosGeneralesCodigoProyecto: file.OCTAVIADatosGeneralesCodigoProyecto,
        PPresLineaInter: file.PPresLineaInter,
        PProaFinanciador: file.PProaFinanciador,
        PProaPaisRegion: file.PProaPaisRegion
      };
    });

    return {
      genericInfo,
      baseLineYears,
      beneficiaries,
      files,
    };
  }

  protected async getStep2(budgetId: number): Promise<IDtoGetStep2 | null> {
    let step2Response = await this.spListService.getItems<ISpfrStep2>({
      listName: Enums.ListTypes.ProaSubproyectoFRStep2,
      filter: String.Format(
        Constants.FiltersFormats.FILTER_BY_BUDGET_GRANT_CODE_NULL,
        budgetId
      ),
      columnsToSelect: Constants.Selects.PROA_SECTION_2,
      expands: Constants.Expands.PROA_SECTION_2,
    });

    if (Utilities.isNullObject(step2Response) || step2Response.length === 0) {
      return null;
    }

    let genericInfo = await Promise.all(
      step2Response.map(async (step2: ISpfrStep2) => {
        let step2Info: any = {};
        step2Info.basicInfo = step2;
        step2Info.implementerYears = await this.spListService.getItems({
          listName: Enums.ListTypes.ProaSubproyectoFRStep2Anios,
          filter: String.Format(
            Constants.FiltersFormats.FILTER_PROA_SUBPROJECT_STEP2,
            step2.Id
          ),
          order: "PPresAnioMeta",
        });

        return step2Info;
      })
    );

    return { genericInfo };
  }

  protected async getStep3(budgetId: number): Promise<IDtoGetStep3> {
    let response: IDtoGetStep3 = {
      adts: [],
      zones: [],
    };

    let results = await this.spListService.getItems<ISpfrStep3>({
      listName: Enums.ListTypes.ProaSubproyectoFRStep3,
      filter: String.Format(
        Constants.FiltersFormats.FILTER_PROA_SUBPROJECT_STEP3_WITH_LOC_AND_ADT,
        budgetId
      ),
      columnsToSelect: Constants.Selects.PROA_SECTION_3_IMPLEMENTERS,
      expands: Constants.Expands.PROA_SECTION_3_IMPLEMENTERS,
    });

    let adts = results.filter(x => x.PProaAdtId)
    let zones = results.filter(y => y.PProaLocationId)

    if (!Utilities.isNullObject(adts) && adts.length > 0) {
      response.adts = await Promise.all(
        adts.map(async (adt: ISpfrStep3) => {
          let step3: any = {};
          step3.genericInfo = adt;
          step3.details = await this.spListService.getItems({
            listName: Enums.ListTypes.ProaSubproyectoFRStep3Anios,
            filter: String.Format(
              Constants.FiltersFormats.FILTER_PROA_SUBPROJECT_STEP3,
              adt.Id
            ),
            order: "PPresAnioMeta",
          });

          return step3;
        })
      );
    }

    if (!Utilities.isNullObject(zones) && zones.length > 0) {
      response.zones = await Promise.all(
        zones.map(async (zone: ISpfrStep3) => {
          let step3: any = {};
          step3.genericInfo = zone;
          step3.details = await this.spListService.getItems({
            listName: Enums.ListTypes.ProaSubproyectoFRStep3Anios,
            filter: String.Format(
              Constants.FiltersFormats.FILTER_PROA_SUBPROJECT_STEP3,
              zone.Id
            ),
            order: "PPresAnioMeta",
          });

          return step3;
        })
      );
    }

    return response;
  }

  protected async getStepSDC(query: any): Promise<IDtoGetStepSDC | null> {
    let filterSDC = query.subventionCodeId ? String.Format(
        Constants.FiltersFormats.FILTER_BY_BUDGET_AND_SUBVENTION_CODE,
        query.budgetId,
        query.subventionCodeId
      ) : String.Format(
        Constants.FiltersFormats.FILTER_BY_BUDGET_GRANT_CODE_NULL,
        query.budgetId
      )
    let stepSDCResponse = await this.spListService.getItems<ISpfrStepSDC>({
      listName: Enums.ListTypes.ProaSubproyectoFRStepSDC,
      filter: filterSDC,
    });
    if (Utilities.isNullObject(stepSDCResponse) || stepSDCResponse.length === 0) {
      return null;
    }

    let auxInfo = await Promise.all(
      stepSDCResponse.map(async (stepSDC: ISpfrStepSDC) => {
        let stepSDCInfo: any = {};
        stepSDCInfo.basicInfo = stepSDC;
        stepSDCInfo.counterpartsYears = await this.spListService.getItems({
          listName: Enums.ListTypes.ProaSubproyectoFRStepSDCAnios,
          filter: String.Format(
            Constants.FiltersFormats.FILTER_PROA_SUBPROJECT_STEPSDC,
            stepSDC.Id
          ),
          order: "PPresAnioMeta",
        });

        return stepSDCInfo;
      })
    );

    let genericInfo = Utilities.copyObject(auxInfo) ;
    return { genericInfo };
  }

  protected async getGapById(gapId: number): Promise<any> {
    return await this.spListService.getItem({
      itemId: gapId,
      listName: Enums.ListTypes.Gaps,
    });
  }

  protected async getFEStep1(query: IGetFEQuery): Promise<IFEStep1Dto | null> {
    const genericInfo: IFEStep1 = {
      OCTAVIAFechaFinalizacion: null,
      OCTAVIAFechaInicio: null,
      PFFRRLineaBase: null,
      PProaAnioLineaBase: new Date(),
      PPresCodSubvencionId: query.subventionCodeId,
      PPresPresupuestoId: query.budgetId,
      PProaMetaFinal: 0,
      PPresTotalAnio: 0,
      PPresIndicadorLineaEstrategica1Id: 0,
      Id: 0,
    };

    let [step1Response, excecutionPeriods] = await Promise.all([this.spListService.getItems<IFEStep1>({
      listName: Enums.ListTypes.ProaSubproyectoFRStep1,
      filter: String.Format(
        Constants.FiltersFormats.FILTER_BY_BUDGET_AND_SUBVENTION_CODE,
        query.budgetId,
        query.subventionCodeId
      ),
    }), this.spListService.getItems<any>({
      listName: Enums.ListTypes.MetaExcecutionPeriod,
      filter: String.Format(
        Constants.FiltersFormats.FILTER_PPRES_GRANT_CODE,
        query.grantCode
      ),order: "Modified",
      ascending: true,
    })]) as any;

    if (step1Response.length === 0 && excecutionPeriods.length === 0) {
      return Promise.resolve(null);
    }

    if (step1Response.length > 0) {
      genericInfo.PFFRRLineaBase = step1Response[0].PFFRRLineaBase;
      genericInfo.PProaAnioLineaBase = step1Response[0].PProaAnioLineaBase;
      genericInfo.PPresCodSubvencionId = step1Response[0].PPresCodSubvencionId;
      genericInfo.PPresPresupuestoId = step1Response[0].PPresPresupuestoId;
      genericInfo.PProaMetaFinal = step1Response[0].PProaMetaFinal;
      genericInfo.PPresTotalAnio = step1Response[0].PPresTotalAnio;
      genericInfo.PPresIndicadorLineaEstrategica1Id = step1Response[0].PPresIndicadorLineaEstrategica1Id;
      genericInfo.Id = step1Response[0].Id;
    }
    
    if (excecutionPeriods.length > 0) {
      genericInfo.OCTAVIAFechaFinalizacion = excecutionPeriods[0].OCTAVIAFechaFinalizacion !== null && excecutionPeriods[0].OCTAVIAFechaFinalizacion !== undefined 
        ? moment.utc(excecutionPeriods[0].OCTAVIAFechaFinalizacion).tz(Constants.GeneralFormats.TIME_ZONE).format(Constants.GeneralFormats.DATE_FORMAT)
        : excecutionPeriods[0].OCTAVIAFechaFinalizacion
      genericInfo.OCTAVIAFechaInicio = excecutionPeriods[0].OCTAVIAFechaInicio !== null && excecutionPeriods[0].OCTAVIAFechaInicio !== undefined
        ? moment.utc(excecutionPeriods[0].OCTAVIAFechaInicio).tz(Constants.GeneralFormats.TIME_ZONE).format(Constants.GeneralFormats.DATE_FORMAT)
        : excecutionPeriods[0].OCTAVIAFechaInicio
    }

    let [baseLineYears, beneficiaries, filesSP] = await Promise.all([
      this.spListService.getItems<IFEStep1Anio>({
        listName: Enums.ListTypes.ProaSubproyectoFRStep1Anios,
        filter: String.Format(
          Constants.FiltersFormats.FILTER_PROA_SUBPROJECT_STEP1,
          genericInfo.Id
        ),
        order: "PPresAnioMeta",
      }),
      this.spListService.getItems<IFEStep1Beneficiario>({
        listName: Enums.ListTypes.BaseFFRRBeneficiarios,
        filter: String.Format(
          Constants.FiltersFormats.FILTER_PROA_SUBPROJECT_STEP1,
          genericInfo.Id
        ),
        order: "PPresuAnio",
      }), this.spFileService.getFiles(genericInfo.Id)]) as any;

    let files: Array<IFileDto> = filesSP.map((file: IFileResponse) => {
      return {
        fileName: file.File.Name,
        filePreviewUrl: file.ServerRedirectedEmbedUri,
        fileRelativeUrl: file.File.ServerRelativeUrl,
        DatosGeneralesCodigoProyecto: file.OCTAVIADatosGeneralesCodigoProyecto,
        PPresLineaInter: file.PPresLineaInter,
        PProaFinanciador: file.PProaFinanciador,
        PProaPaisRegion: file.PProaPaisRegion
      };
    });

    let metaBeneficiaries: IFEStep1Beneficiario = {
      PFFRRTotalHombres: 0,
      PFRRTotalMujeres: 0,
      PPresTotalAnio: 0,
      PPresuAnio: "0",
      PProaFRStep1Id: 0,
      PPresPresupuestoId: 0,
    };

    let projectId = excecutionPeriods.length === 0
        ? 0
        : excecutionPeriods[0].OCTAVIAProyectoId;
    if (projectId != 0) {
      let technicalAspects = await this.spListService.getItems<any>({
        listName: Enums.ListTypes.MetaTechnicalAspects,
        filter: String.Format(
          Constants.FiltersFormats.FILTER_BY_PROJECT_ID,
          projectId
        ),order: "Modified",
        ascending: true,
      });

      if (technicalAspects.length > 0) {
        let colectives = await this.spListService.getItems<any>({
          listName: Enums.ListTypes.MetaBeneficiaryCollectives,
          filter: String.Format(
            Constants.FiltersFormats.FILTER_BY_TECNICAL_ASPECT,
            technicalAspects[0].Id
          ),order: "Modified",
          ascending: true,
        });

        colectives.forEach((colective: any) => {
          metaBeneficiaries.PFFRRTotalHombres +=
            colective.MetaCantidadHombres ?? 0;
          metaBeneficiaries.PFRRTotalMujeres +=
            colective.MetaCantidadMujeres ?? 0;
          metaBeneficiaries.PPresTotalAnio +=
            metaBeneficiaries.PFFRRTotalHombres +
            metaBeneficiaries.PFRRTotalMujeres;
        });
      }
    }

    return {
      genericInfo,
      baseLineYears,
      beneficiaries,
      files,
      metaBeneficiaries,
    } as IFEStep1Dto;
  }

  protected async getFEStep2(query: IGetFEQuery): Promise<IFEStep2Dto | null> {
    let step2Response = await this.spListService.getItems<IFEStep2>({
      listName: Enums.ListTypes.ProaSubproyectoFRStep2,
      filter: String.Format(
        Constants.FiltersFormats.FILTER_BY_BUDGET_AND_SUBVENTION_CODE,
        query.budgetId,
        query.subventionCodeId
      ),order: "Modified",
      ascending: true,
      columnsToSelect: Constants.Selects.PROA_SECTION_2,
      expands: Constants.Expands.PROA_SECTION_2,
    });

    if (Utilities.isNullObject(step2Response) || step2Response.length === 0) {
      return Promise.resolve(null);
    }

    let genericInfo = await Promise.all(
      step2Response.map(async (step2: IFEStep2) => {
        let step2Info: IFEStep2DtoModel = {
          basicInfo: null,
          implementerYears: [],
        };
        step2Info.basicInfo = step2;
        step2Info.implementerYears = await this.spListService.getItems({
          listName: Enums.ListTypes.ProaSubproyectoFRStep2Anios,
          filter: String.Format(
            Constants.FiltersFormats.FILTER_PROA_SUBPROJECT_STEP2,
            step2.Id
          ),
          order: "PPresAnioMeta",
        });

        return step2Info;
      })
    );

    return { genericInfo } as IFEStep2Dto;
  }

  protected async getFEStep3(query: IGetFEQuery): Promise<IFEStep3Dto> {
    let response: IFEStep3Dto = {
      adts: [],
      zones: [],
    };

    let results = await this.spListService.getItems<IFEStep3>({
      listName: Enums.ListTypes.ProaSubproyectoFRStep3,
      filter: String.Format(
        Constants.FiltersFormats
          .FILTER_BY_BUDGET_AND_SUBVENTION_CODE,
        query.budgetId,
        query.subventionCodeId
      ),
      columnsToSelect: Constants.Selects.PROA_SECTION_3_IMPLEMENTERS,
      expands: Constants.Expands.PROA_SECTION_3_IMPLEMENTERS,
    });
    
    let adts = results.filter(x => x.PProaAdtId)
    let zones = results.filter(y => y.PProaLocationId)

    if (!Utilities.isNullObject(adts) && adts.length > 0) {
      response.adts = await Promise.all(
        adts.map(async (adt: IFEStep3) => {
          let step3: any = {};
          step3.genericInfo = adt;
          step3.details = await this.spListService.getItems({
            listName: Enums.ListTypes.ProaSubproyectoFRStep3Anios,
            filter: String.Format(
              Constants.FiltersFormats.FILTER_PROA_SUBPROJECT_STEP3,
              adt.Id
            ),
            order: "PPresAnioMeta",
          });

          return step3;
        })
      );
    }

    if (!Utilities.isNullObject(zones) && zones.length > 0) {
      response.zones = await Promise.all(
        zones.map(async (zone: IFEStep3) => {
          let step3: any = {};
          step3.genericInfo = zone;
          step3.details = await this.spListService.getItems({
            listName: Enums.ListTypes.ProaSubproyectoFRStep3Anios,
            filter: String.Format(
              Constants.FiltersFormats.FILTER_PROA_SUBPROJECT_STEP3,
              zone.Id
            ),
            order: "PPresAnioMeta",
          });

          return step3;
        })
      );
    }

    return response;
  }

  protected async getFEStep4Mri(
    query: IGetFEQuery
  ): Promise<IFEStep4MriIndicadorDtoModel[] | null> {
    let step4MriResponse = await this.spListService.getItems<IFEStep4IndicadorMri>({
      listName: Enums.ListTypes.ProaSubproyectoFEStep4MRI,
      filter: String.Format(
        Constants.FiltersFormats.FILTER_BY_BUDGET_AND_SUBVENTION_CODE,
        query.budgetId,
        query.subventionCodeId
      ),order: "Modified",
      ascending: true,
    });

    if (Utilities.isNullObject(step4MriResponse) || step4MriResponse.length === 0) {
      return [];
    }

    return await Promise.all(
      step4MriResponse.map(async (step4Mri: IFEStep4IndicadorMri) => {
        
        let step4Info: IFEStep4MriIndicadorDtoModel = {
          genericInfo: null,
          years: [],
        };
        step4Info.genericInfo = step4Mri;
        step4Info.years = await this.spListService.getItems({
          listName: Enums.ListTypes.ProaSubproyectoFEStep4MRIAnios,
          filter: String.Format(
            Constants.FiltersFormats.FILTER_FE_STEP_4_MRI,
            step4Mri.Id
          ),order: "Modified",
          ascending: true,
        });

        return step4Info;
      })
    );
  }

  protected async getFEStep4(
    query: IGetFEQuery
  ): Promise<IFEStep4Dto[] | null> {
    let step4Response = await this.spListService.getItems<IFEStep4>({
      listName: Enums.ListTypes.ProaSubproyectoFEStep4,
      filter: String.Format(
        Constants.FiltersFormats.FILTER_BY_BUDGET_AND_SUBVENTION_CODE,
        query.budgetId,
        query.subventionCodeId
      ),order: "Modified",
      ascending: true,
    });

    if (Utilities.isNullObject(step4Response) || step4Response.length === 0) {
      return null;
    }

    return await Promise.all(
      step4Response.map(async (step4: IFEStep4) => {
        let step4Objetives: IFEStep4IndicadorObjetivo[] = await this.spListService.getItems<
          IFEStep4IndicadorObjetivo
        >({
          listName: Enums.ListTypes.ProaSubproyectoFEStep4Objetivo,
          filter: String.Format(
            Constants.FiltersFormats.FILTER_FE_STEP_4,
            step4.Id
          ),order: "Modified",
          ascending: true,
        });

        let objetives: IFEStep4IndicadoresDtoModel[] = await Promise.all(
          step4Objetives.map(
            async (step4Objetive: IFEStep4IndicadorObjetivo) => {
              let step2Info: IFEStep4IndicadoresDtoModel = {
                genericInfo: null,
                years: [],
              };
              step2Info.genericInfo = step4Objetive;
              step2Info.years = await this.spListService.getItems({
                listName: Enums.ListTypes.ProaSubproyectoFEStep4ObjetivoAnios,
                filter: String.Format(
                  Constants.FiltersFormats.FILTER_FE_STEP_4_OBJETIVE,
                  step4Objetive.Id
                ), order: "Modified",
                ascending: true,
                
              });

              return step2Info;
            }
          )
        );

        let step4Results = await this.spListService.getItems<
          IFEStep4ResultadoEsperado
        >({
          listName: Enums.ListTypes.ProaSubproyectoFEStep4Resultados,
          filter: String.Format(
            Constants.FiltersFormats.FILTER_FE_STEP_4,
            step4.Id
          ),
          order: "Id",
          ascending: true,
        });

        let results: IFEStep4ResultsDtoModel[] = await Promise.all(
          step4Results.map(async (resultStep4: IFEStep4ResultadoEsperado) => {
            let result: IFEStep4ResultsDtoModel = {
              activities: [],
              genericInfo: null,
              details: [],
            };
            result.genericInfo = resultStep4;

            let expectedResults = await this.spListService.getItems<
              IFEStep4ResultadoEsperadoDetalle
            >({
              listName:
                Enums.ListTypes.ProaSubproyectoFEStep4ResultadosDetalles,
              filter: String.Format(
                Constants.FiltersFormats.FILTER_FE_STEP_4_RESULTS,
                result.genericInfo.Id
              ), order: "Modified",
              ascending: true,
            });

            let details: IFEStep4ResultsDetailsDtoModel[] = await Promise.all(
              expectedResults.map(
                async (expectedResult: IFEStep4ResultadoEsperadoDetalle) => {
                  let detail: IFEStep4ResultsDetailsDtoModel = {
                    genericInfo: null,
                    years: [],
                  };
                  detail.genericInfo = expectedResult;

                  detail.years = await this.spListService.getItems({
                    listName:
                      Enums.ListTypes
                        .ProaSubproyectoFEStep4ResultadosDetallesAnios,
                    filter: String.Format(
                      Constants.FiltersFormats.FILTER_FE_STEP_4_RESULT_DETAIL,
                      expectedResult.Id
                    ), order: "Modified",
                    ascending: true,
                  });

                  return detail;
                }
              )
            );

            result.details = details;

            let activitiesResponse = await this.spListService.getItems<
              IFEStep4Actividad
            >({
              listName: Enums.ListTypes.ProaSubproyectoFEStep4Actividad,
              filter: String.Format(
                Constants.FiltersFormats.FILTER_FE_STEP_4_RESULTS,
                result.genericInfo.Id
              ), order: "Modified",
              ascending: true,
            });

            let activities: IFEStep4ActivitiesDtoModel[] = await Promise.all(
              activitiesResponse.map(
                async (activityResponse: IFEStep4Actividad) => {
                  let detail: IFEStep4ActivitiesDtoModel = {
                    genericInfo: null,
                    years: [],
                  };
                  detail.genericInfo = activityResponse;

                  detail.years = await this.spListService.getItems({
                    listName:
                      Enums.ListTypes.ProaSubproyectoFEStep4ActividadAnios,
                    filter: String.Format(
                      Constants.FiltersFormats.FILTER_FE_STEP_4_ACTIVITY_DETAIL,
                      activityResponse.Id
                    ), order: "Modified",
                  });

                  return detail;
                }
              )
            );

            result.activities = activities;

            return result;
          })
        );

        return {
          genericInfo: step4,
          objetives: objetives,
          results: results,
        } as IFEStep4Dto;
      })
    );
  }

  //#endregion

  //#region Update
  protected async updateStep1(step1: ICmdSpfrStep1Update, userId: number): Promise<any> {
    step1.genericInfo.PProaAnioLineaBase = step1.genericInfo.PProaAnioLineaBase ? `${(Number(step1.genericInfo.PProaAnioLineaBase.getMonth())+1)}/${step1.genericInfo.PProaAnioLineaBase.getFullYear()}` : null;
    (step1.genericInfo as any).PProaModifiedById = userId;
    step1.genericInfo.PPresIndicadorLineaEstrategica1Id = Array.isArray(step1.genericInfo.PPresIndicadorLineaEstrategica1Id) ? step1.genericInfo.PPresIndicadorLineaEstrategica1Id.length > 0 ? step1.genericInfo.PPresIndicadorLineaEstrategica1Id[0] : null : step1.genericInfo.PPresIndicadorLineaEstrategica1Id; 

    let step1Response = await this.spListService.updateItem({
      itemId: step1.genericInfo.Id,
      listName: Enums.ListTypes.ProaSubproyectoFRStep1,
      item: step1.genericInfo,
    });

    await Promise.all([
      this.saveStep1BaseLine(
        step1.baseLineYears.filter((x) => 0 === x.Id),
        step1.genericInfo.Id
      ),
      this.updateStep1BaseLine(
        step1.baseLineYears.filter((x) => 0 !== x.Id)
      ),
      this.saveStep1Beneficiaries(
        step1.beneficiaries.filter((x) => 0 === x.Id),
        step1.genericInfo.Id
      ),
      this.updateStep1Beneficiaries(
        step1.beneficiaries.filter((x) => 0 !== x.Id)
      )
    ]);

    if (step1.files && step1.files.length > 0) {      
      await Promise.all(step1.files.map(async (file: IFileDto) => {
          return await this.spFileService.uploadFile(file.file, {
            PProaFRStep1Id: step1.genericInfo.Id,
            Title: file.fileName,
            OCTAVIADatosGeneralesCodigoProyecto: file.OCTAVIADatosGeneralesCodigoProyecto,
            PPresLineaInter: file.PPresLineaInter,
            PProaFinanciador: file.PProaFinanciador,
            PProaPaisRegion: file.PProaPaisRegion
          });
        })
      );
    }
    return step1Response;
  }

  protected async updateFEStep1(step1: IFEStep1Dto, userId: number): Promise<any> {
    (step1.genericInfo as any).PProaAnioLineaBase = step1.genericInfo.PProaAnioLineaBase ? `${(Number((step1.genericInfo as any).PProaAnioLineaBase.getMonth())+1)}/${(step1.genericInfo as any).PProaAnioLineaBase.getFullYear()}` : null;
    (step1.genericInfo as any).PProaModifiedById = userId;
    step1.genericInfo.PPresIndicadorLineaEstrategica1Id = Array.isArray(step1.genericInfo.PPresIndicadorLineaEstrategica1Id) ? step1.genericInfo.PPresIndicadorLineaEstrategica1Id.length > 0 ? step1.genericInfo.PPresIndicadorLineaEstrategica1Id[0] : null : step1.genericInfo.PPresIndicadorLineaEstrategica1Id; 

    let step1Response = await this.spListService.updateItem({
      itemId: step1.genericInfo.Id,
      listName: Enums.ListTypes.ProaSubproyectoFRStep1,
      item: step1.genericInfo,
    });

    await Promise.all([this.saveStep1BaseLine(
        step1.baseLineYears.filter((x) => 0 === x.Id),
        step1.genericInfo.Id
      ), this.updateStep1BaseLine(
        step1.baseLineYears.filter((x) => 0 !== x.Id)
      ),this.saveFEStep1Beneficiaries(
        step1.beneficiaries.filter((x) => 0 === x.Id),
        step1.genericInfo.Id
      ),this.updateFEStep1Beneficiaries(
        step1.beneficiaries.filter((x) => 0 !== x.Id)
      )
    ]);
    
    if (step1.files && step1.files.length > 0) {
      await Promise.all(step1.files.map(async (file: IFileDto) => {
          return await this.spFileService.uploadFile(file.file, {
            PProaFRStep1Id: step1.genericInfo.Id,          
            Title: file.fileName,
            OCTAVIADatosGeneralesCodigoProyecto: file.OCTAVIADatosGeneralesCodigoProyecto,
            PPresLineaInter: file.PPresLineaInter,
            PProaFinanciador: file.PProaFinanciador,
            PProaPaisRegion: file.PProaPaisRegion
          });
        })
      );
    }

    return step1Response;
  }

  protected async updateStep1BaseLine(
    baseLines: Array<ISpfrStep1Anio>
  ): Promise<any> {
    return await Promise.all(
      baseLines.map(async (data: ISpfrStep2Anio) => {
        return await this.spListService.updateItem({
          itemId: data.Id,
          listName: Enums.ListTypes.ProaSubproyectoFRStep1Anios,
          item: data,
        });
      })
    );
  }

  protected async updateStep1Beneficiaries(
    beneficiaries: Array<ISpfrStep1Beneficiary>
  ): Promise<any> {
    return await Promise.all(
      beneficiaries.map(async (data: ISpfrStep1Beneficiary) => {
        return await this.spListService.updateItem({
          itemId: data.Id,
          listName: Enums.ListTypes.BaseFFRRBeneficiarios,
          item: data,
        });
      })
    );
  }

  protected async updateFEStep1Beneficiaries(
    beneficiaries: Array<IFEStep1Beneficiario>
  ): Promise<any> {
    return await Promise.all(
      beneficiaries.map(async (data: IFEStep1Beneficiario) => {
        return await this.spListService.updateItem({
          itemId: data.Id,
          listName: Enums.ListTypes.BaseFFRRBeneficiarios,
          item: data,
        });
      })
    );
  }

  protected async updateStep2(
    step2: ICmdSpfrStep2Update,
    budgetId: number
  ): Promise<any> {

    let res = await Promise.all([this.updateStep2Implementers(
        step2.genericInfo.filter((x) => 0 !== x.basicInfo.Id)
      ), this.saveStep2(
        step2.genericInfo.filter((x) => 0 === x.basicInfo.Id),
        budgetId
      )
    ]);

    if (step2.genericInfoToDelete) await this.deleteStep2Implementers(step2.genericInfoToDelete);

    return res;
  }

  protected async updateFEStep2(step2: IFEStep2Dto): Promise<any> {
   
    return await Promise.all([this.updateStep2Implementers(
        step2.genericInfo.filter((x) => 0 !== x.basicInfo.Id)
      ), this.saveFEStep2Back(
        step2.genericInfo.filter((x) => 0 === x.basicInfo.Id)
      )
    ]);
  }

  protected async updateStep2Implementers(
    stepData: Array<IDtoStep2>
  ): Promise<any> {
    return await Promise.all(
      stepData.map(async (data: IDtoStep2) => {
        let res = await this.spListService.updateItem({
          itemId: data.basicInfo.Id,
          listName: Enums.ListTypes.ProaSubproyectoFRStep2,
          item: data.basicInfo,
        });

        let newImplementers = data.implementerYears.filter((x) => 0 === x.Id);
        let updateImplementers = data.implementerYears.filter((x) => 0 !== x.Id);

        for (const stepAnios of newImplementers) {
          await this.spListService.addItem({
            listName: Enums.ListTypes.ProaSubproyectoFRStep2Anios,
            item: stepAnios,
          });
        };

        for (const stepAnios of updateImplementers) {
          await this.spListService.updateItem({
            listName: Enums.ListTypes.ProaSubproyectoFRStep2Anios,
            item: stepAnios,
            itemId: stepAnios.Id,
          });
        };

        return res;
      })
    );
  }

  protected async updateStep3(
    step3: ICmdSpfrStep3Update,
    budgetId: number
  ): Promise<any> {
    return await Promise.all([
      this.updateStep3AdtZone(step3.adts.filter((x) => 0 !== x.genericInfo.Id)),
      this.updateStep3AdtZone(step3.zones.filter((x) => 0 !== x.genericInfo.Id)),
      this.saveStep3(
        step3.adts.filter((x) => 0 === x.genericInfo.Id),
        budgetId
      ),
      this.saveStep3(
        step3.zones.filter((x) => 0 === x.genericInfo.Id),
        budgetId
      ),
      this.deleteStep3AdtZone(step3.adtsToDelete),
      this.deleteStep3AdtZone(step3.zonesToDelete),
    ]);
  }

  protected async updateFEStep3(step3: IFEStep3Dto): Promise<any> {

    return await Promise.all([this.updateStep3AdtZone(
        step3.adts.filter((x) => 0 !== x.genericInfo.Id)
      ), this.updateStep3AdtZone(
        step3.zones.filter((x) => 0 !== x.genericInfo.Id)
      ), this.saveFEStep3Back(
        step3.adts.filter((x) => 0 === x.genericInfo.Id)
      ), this.saveFEStep3Back(
        step3.zones.filter((x) => 0 === x.genericInfo.Id)
      )
    ]);
  }

  protected async updateStep3AdtZone(
    stepData: Array<IDtoAdtZonaSave>
  ): Promise<any> {
    return await Promise.all(
      stepData.map(async (adtZoneData: IDtoAdtZonaSave) => {
        let adtZone = adtZoneData.genericInfo;

        let res = await this.spListService.updateItem({
          listName: Enums.ListTypes.ProaSubproyectoFRStep3,
          item: adtZone,
          itemId: adtZone.Id,
        });

        let aniosToUpdate = adtZoneData.details.filter((x) => 0 !== x.Id);
        let aniosToCreate = adtZoneData.details.filter((x) => 0 === x.Id);

        await Promise.all(
          aniosToUpdate.map(async (anio: ISpfrStep3Anios) => {
            return await this.spListService.updateItem({
              listName: Enums.ListTypes.ProaSubproyectoFRStep3Anios,
              itemId: anio.Id,
              item: anio,
            });
          })
        );

        await Promise.all(
          aniosToCreate.map(async (anio: ISpfrStep3Anios) => {
            anio.PProaFRStep3Id = adtZone.Id;
            return await this.spListService.addItem({
              listName: Enums.ListTypes.ProaSubproyectoFRStep3Anios,
              item: anio,
            });
          })
        );

        return res;
      })
    );
  }

  protected async updateStepSDC(
    stepSDC: ICmdSpfrStepSDCUpdate,
    budgetId: number,
    currentUserId: number
  ): Promise<any> {

    if (stepSDC.genericInfoToDelete) await this.deleteStepSDCCounterparts(stepSDC.genericInfoToDelete);

    return await Promise.all([this.updateStepSDCCounterparts(
        stepSDC.genericInfo.filter((x) => 0 !== x.basicInfo.Id),
        currentUserId
      ), this.saveStepSDC(
        stepSDC.genericInfo.filter((x) => 0 === x.basicInfo.Id),
        budgetId,
        currentUserId
      )
    ]);
  }

  protected async updateStepSDCCounterparts(
    stepData: Array<IDtoStepSDC>,
    currentUserId: number
  ): Promise<any> {
    return await Promise.all(
      stepData.map(async (data: IDtoStepSDC) => {
        data.basicInfo.PProaModifiedById = currentUserId;
        await this.spListService.updateItem({
          itemId: data.basicInfo.Id,
          listName: Enums.ListTypes.ProaSubproyectoFRStepSDC,
          item: data.basicInfo,
        });

        let newCounterparts = data.counterpartYears.filter((x) => 0 === x.Id);
        let updateCounterparts = data.counterpartYears.filter((x) => 0 !== x.Id);

        for (const stepAnios of newCounterparts) {
          stepAnios.PProaModifiedById = currentUserId;
          await this.spListService.addItem({
            listName: Enums.ListTypes.ProaSubproyectoFRStepSDCAnios,
            item: stepAnios,
          });
        };

        for (const stepAnios of updateCounterparts) {
          stepAnios.PProaModifiedById = currentUserId;
          await this.spListService.updateItem({
            listName: Enums.ListTypes.ProaSubproyectoFRStepSDCAnios,
            item: stepAnios,
            itemId: stepAnios.Id,
          });
        };
      })
    );
  }

  //#endregion

  //#region Delete
  protected async deleteStep2Implementers(
    stepData: Array<number>
  ): Promise<any> {
    return await Promise.all(
      stepData.map(async (data: number) => {
        let anios = await this.spListService.getItems({
          listName: Enums.ListTypes.ProaSubproyectoFRStep2Anios,
          filter: String.Format(
            Constants.FiltersFormats.FILTER_PROA_SUBPROJECT_STEP2,
            data
          ),
        });

        await Promise.all(
          anios.map(async (x: any) => {
            return await this.spListService.deleteItem({
              itemId: x.Id,
              listName: Enums.ListTypes.ProaSubproyectoFRStep2Anios,
            });
          })
        );

        await this.spListService.deleteItem({
          itemId: data,
          listName: Enums.ListTypes.ProaSubproyectoFRStep2,
        });

        return anios;
      })
    );
  }

  protected async deleteStep3AdtZone(stepData: Array<number>): Promise<any> {
    return await Promise.all(
      stepData.map(async (data: number) => {
        let anios = await this.spListService.getItems({
          listName: Enums.ListTypes.ProaSubproyectoFRStep3Anios,
          filter: String.Format(
            Constants.FiltersFormats.FILTER_PROA_SUBPROJECT_STEP3,
            data
          ),
        });

        await Promise.all(
          anios.map(async (x: any) => {
            return await this.spListService.deleteItem({
              itemId: x.Id,
              listName: Enums.ListTypes.ProaSubproyectoFRStep3Anios,
            });
          })
        );

        await this.spListService.deleteItem({
          itemId: data,
          listName: Enums.ListTypes.ProaSubproyectoFRStep3,
        });

        return anios;
      })
    );
  }

  protected async deleteStepSDCCounterparts(
    stepData: Array<number>
  ): Promise<any> {
    return await Promise.all(
      stepData.map(async (data: number) => {
        let anios = await this.spListService.getItems({
          listName: Enums.ListTypes.ProaSubproyectoFRStepSDCAnios,
          filter: String.Format(
            Constants.FiltersFormats.FILTER_PROA_SUBPROJECT_STEPSDC,
            data
          ),
        });

        await Promise.all(
          anios.map(async (x: any) => {
            return await this.spListService.deleteItem({
              itemId: x.Id,
              listName: Enums.ListTypes.ProaSubproyectoFRStepSDCAnios,
            });
          })
        );

        await this.spListService.deleteItem({
          itemId: data,
          listName: Enums.ListTypes.ProaSubproyectoFRStepSDC,
        });

        return anios;
      })
    );
  }

  protected createLookupObjectMultiValue(values: any) {
    return { __metadata: { type: "Collection(Edm.Int32)" }, results: values };
  }
  //#endregion
}
